import * as React from 'react'
import { LogPointType } from '../../../util/LoggingPolicyConfigurations'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import './LogPointsSidebarHeaderItem.css'

export type ValueProps = {
  icon?: string
  type: LogPointType
  testId?: string
}

export type Props = ValueProps

export const LogPointsSidebarHeaderItem = (props: Props) => {
  const {icon, type, testId} = props
  return (
    <div className="log-points-sidebar-header-item" data-test-id={`log-points-sidebar-header-item-${testId}`}>
      {icon && <IconPanel name={icon} size={15} testId={`log-points-sidebar-header-item-icon-${testId}`}/>}
      <span className="log-points-sidebar-header-item-label" data-test-id={`log-points-sidebar-header-item-label-${testId}`}>{type}</span>
    </div>
  )
}
